import React from "react";
import { joinClasses } from "../../../../../Utils/className.util";

interface Props{
	name: string;
}

const Icon: React.FC<Props> = ({name}) => <i className={joinClasses(["fa-solid", name])}/>

export default Icon;
